// extracted by mini-css-extract-plugin
export default {"Form":"CheckoutForm_Form__+sj+w"};